module.exports = __webpack_public_path__ + "img/reading-fc.4634ea3c.png";